export class SIQLogViewTheme {
  backgroundColor = "null";
  titleColor = "null";
  textViewColor = "null";
  textViewBackgroundColor = "null";
  sendTitleColor = "null";
  sendBackgroundColor = "null";
  cancelTitleColor = "null";
}
//# sourceMappingURL=SIQLogViewTheme.js.map